import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    height: "100%",
    "@media (min-width: 1200px)": {
      maxWidth: "none",
    },
  },
  tableContainer: {
    padding: 0,
    width: "100%",
    "@media (min-width: 1200px)": {
      maxWidth: "none",
    },
  },
  tableInnerContainer: {
    maxHeight: "100%",
  },
  buttonContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  buttonPrimary: {
    background: theme.palette.Primary.background,
    "&:hover": {
      backgroundColor: theme.palette.Primary.hoverButton,
      color: theme.palette.Primary.light,
    },
    width: 170,
    height: 46,
    fontSize: 14,
    marginLeft: theme.spacing(2),
    marginTop: 0,
    fontWeight: 400,
    textTransform: "capitalize",
  },
  loader: {
    width: "100%",
    height: 100,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  closeIcon: {
    position: "absolute",
    zIndex: 999,
    right: 40,
    top: 20,
  },
  topContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  filterContainer: {
    display: "flex",
    width: "85%",
    justifyContent: "space-between",
  },
  selectContainer: {
    width: "100%",
    marginRight: theme.spacing(4),
  },
  textField: {
    backgroundColor: "white",
    marginRight: theme.spacing(4),
  },
  autoComplete: {
    width: "100%",
    marginRight: theme.spacing(4),
  },
  backContainer: {
    color: theme.palette.Primary.background,
    textTransform: "capitalize",
    display: "flex",
    paddingBottom: 35,
    paddingTop: 10,
    alignItems: "center",
    cursor: "pointer",
    justifyContent: "space-between",
  },
  backButtonDiv: {
    alignItems: "center",
    display: "flex",
    // paddingLeft: '28px'
  },
  templateButtonDiv: {
    paddingRight: "20px",
  },
  bulkButton: {
    background: theme.palette.Primary.background,
    textTransform: "capitalize",
    whiteSpace: "nowrap",
    marginRight: 15,
    fontWeight: 400,
    width: 170,
    height: 42,
    "&:hover": {
      backgroundColor: theme.palette.Primary.hoverButton,
      color: theme.palette.Primary.light,
    },
  },
  subDialog: {
    width: "700px !important",
    textAlign: "center",
    "& .MuiDialog-container > .MuiPaper-root": {
      backgroundColor: "white",
    },
  },
  popUp: {
    margin: "auto",
  },
  fileDiv: {
    textAlign: "left",
    margin: "10px 0px",
  },
  linkText: { textDecoration: "underline", color: "#25aac3", padding: "3px" },
  linkDiv: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  buttonSecondary: {
    color: theme.palette.Primary.background,
    borderColor: theme.palette.Primary.background,
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: theme.palette.Primary.hoverButton,
      color: theme.palette.Primary.light,
    },
    marginRight: theme.spacing(5),
  },

  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    // backgroundColor: 'rgba(0, 0, 0, 0.7)',
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: "2px solid black",
    zIndex: 9999999,
  },
  modal: {
    backgroundColor: "#fff",
    padding: "20px",
    borderRadius: "5px",
    width: "400px",
    maxWidth: "100%",
    border: "2px solid black",
  },
  footer: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "10px",
  },
  button: {
    padding: "10px 15px",
    cursor: "pointer",
    backgroundColor: "#007BFF",
    color: "white",
    border: "none",
    borderRadius: "4px",
  },
  popUpTitle: {
    marginTop: "30px",
  },
}));

export default useStyles;
